import * as moment from "moment";
import * as React from "react";
import * as Constants from "../../core/constants";
import IStatusChangePostLog from "../../types/IStatusChangePostLog";

interface IPostbackLogRowProps {
    log: IStatusChangePostLog;
    onRowClick(log: IStatusChangePostLog): void;
}

function PostbackLogRow(p: IPostbackLogRowProps) {

    function onClick() {
        p.onRowClick(p.log);
    }

    return (
        <tr className="postbacklog-row" onClick={onClick}>
            <td>{p.log.referenceID}</td>
            <td>{p.log.uniqueID}</td>
            <td>{moment(p.log.dateTimeCreated).format(Constants.MOMENT_FORMAT_DATETIME)}</td>
            <td>{p.log.action}</td>
            <td>{p.log.messageType}</td>
        </tr>
    );
}

export default PostbackLogRow;



// WEBPACK FOOTER //
// ./src/components/PostbackLogList/PostbackLogRow.tsx